import React from 'react'
import './footer.css'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {SiLeetcode} from 'react-icons/si'
import {BsInstagram} from 'react-icons/bs'
import { BsMedium } from 'react-icons/bs'

const Footer = () => {
  return (
    <footer>
      <a href="#home" className='footer_logo'>Abdullah Sattar</a>
      <ul className='permalinks'>
        <li><a href='#home'>Home</a></li>
        <li><a href='#about'>About Me</a></li>
        <li><a href='#work'>Work</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#services'>Services</a></li>
        {/* <li><a href='#certificates'>Certificates & Badges</a></li> */}
        <li><a href='#testimonials'>Testimonials</a></li>        
        <li><a href='#contact'>Contact Me</a></li>
      </ul>

      <div className='footer_socials'>
      <a href='https://www.linkedin.com/in/abdullahsattar4/' target='_blank' rel='noreferrer'><BsLinkedin/></a>
        <a href='https://github.com/abdullahsattaar' target='_blank' rel='noreferrer'><FaGithub/></a>
        <a href='https://leetcode.com/u/abdullahsattar' target='_blank' rel='noreferrer'><SiLeetcode/></a>
        <a href='https://www.instagram.com/abdullahsattaar/' target='_blank' rel='noreferrer'><BsInstagram/></a>
        <a href='https://medium.com/@abdullahsattaar' target='_blank' rel='noreferrer'><BsMedium/></a>
      </div>

      <div className='footer_copyright'>
        <small>Copyright &copy; 2023-2026 Abdullah Sattar, All rights reserved.</small>
      </div>
    </footer>

  )
}

export default Footer